import { ShoppingBag } from "lucide-react";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function ShopPage() {
  usePageTitle("Niners-Shop");
  return (
    <div className="py-12 md:py-24 px-4 md:px-8" data-testid="shop-page">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <ShoppingBag className="w-8 h-8" style={{ color: "#a855f7" }} />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight" style={{ fontFamily: 'Oswald' }}>
            Niners<span style={{ color: '#a855f7' }}>-Shop</span>
          </h1>
        </div>

        {/* Shop Description */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-10">
          <div className="space-y-6">
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              In unserem Niners-Shop findest du eine sorgfältig ausgewählte Auswahl an Dart- und Billardzubehör – direkt vor Ort.
            </p>
            
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Egal ob Einsteiger oder ambitionierter Spieler:<br />
              Wir haben alles, was du für dein Spiel brauchst – von Darts, Flights und Shafts bis hin zu Queues, Kreide und weiterem Zubehör.
            </p>
            
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              <span className="text-foreground font-semibold">Das Beste daran:</span><br />
              Du kannst die Produkte direkt bei uns im Lokal ausprobieren, dich beraten lassen und gleich das passende Equipment mitnehmen.
            </p>
            
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Unser Sortiment wird laufend erweitert und auf unsere Gäste abgestimmt – ein Besuch lohnt sich also immer.
            </p>
          </div>

          <div className="relative">
            <img 
              src="/assets/9h6zzjqu_03_mehr_Farbe.jpg" 
              alt="Niners Shop - Dart und Billard Zubehör" 
              className="w-full h-auto rounded-lg border border-white/10 shadow-xl"
              data-testid="shop-image"
            />
            <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
          </div>
        </div>
      </div>
    </div>
  );
}
